import React from "react";

import styles from "./HighlightBox.module.scss";
import { ReactComponent as Warning } from "assets/misc/warning_circle.svg";

interface HighlightBoxProps {
  title: string;
  text: string;
  onClose?: () => void;
}

const HighlightBox = ({ title, text, onClose }: HighlightBoxProps) => {
  return (
    <div className={styles.box}>
      <div className={styles.contents}>
        <div className={styles.header}>
          <Warning />
          <span>Warning: {title}</span>
        </div>
        <span>{text}</span>
      </div>
      {onClose !== undefined && (
        <div className={styles.closeButtonArea}>
          <div className={styles.closeButton} onClick={onClose}>
            Close
          </div>
        </div>
      )}
    </div>
  );
};

export default HighlightBox;
